const baseURL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:4000"
    : "https://api.meruwell.com";
// : "http://meruwellapi.sarvanala.com";

export default baseURL;
